import VFooter from './VFooter'

/* istanbul ignore next */
VFooter.install = function install (Vue) {
  Vue.component(VFooter.name, VFooter)
}

export default VFooter



// WEBPACK FOOTER //
// ./src/components/VFooter/index.js